import React, { Component } from "react";
class Footer extends Component {
  render() {
    return (
      <>
        <section className="lg:relative bg-black text-white  ">
          <div className=" max-w-xl text-center pt-24 mx-auto">
            <h2 className="font-black text-6xl">Start for free.</h2>
            <p className="text-3xl mt-6 mb-12 text-gray-400">
              Design and launch the digital version of your business today!
            </p>
            <button className="rounded-md bg-gray-100 text-black text-xl font-bold px-8 py-3">
              Start for free
            </button>
          </div>

          <div className="mx-auto max-w-screen-2xl grid grid-cols-4 py-32 gap-12  text-white  ">
            <div>
              <img src="images/smallbee.svg" alt="" />
            </div>
            <div>
              {" "}
              <h4 className="font-medium text-xl mb-4">Company</h4>
              <ul>
                <li className="mb-2">About</li>
                <li className="mb-2">Team</li>
                <li className="mb-2">Terms</li>
                <li className="mb-2">Security</li>
              </ul>
            </div>
            <div>
              {" "}
              <h4 className="font-medium text-xl mb-4">Service</h4>
              <ul>
                <li className="mb-2">About</li>
                <li className="mb-2">Team</li>
                <li className="mb-2">Terms</li>
                <li className="mb-2">Security</li>
              </ul>
            </div>
            <div>
              {" "}
              <h4 className="font-medium text-xl">Service</h4>
              <ul>
                <li>FAQs</li>
                <li>Terms</li>
                <li>Security</li>
                <li>Privacy</li>
              </ul>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Footer;
